import fetchClient from '@/api/api-client'

import { AffUser } from './types/AffUser'

export async function getRef(refNum: string): Promise<AffUser> {
  try {
    const res = await fetchClient.get(`affiliate/${refNum}`)
    return res.data.data.response
  } catch (err) {
    throw err
  }
}

export async function sendEmailAffReq(data: string) {
  const payload = { data }
  try {
    const res = await fetchClient.post(`/sendEmail`, payload)
    return res.data
  } catch (err) {
    throw err
  }
}
